"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Link = _interopRequireDefault(require("@material-ui/core/Link"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var Link = function Link(_ref) {
  var _classNames;

  var className = _ref.className,
      block = _ref.block,
      onClick = _ref.onClick,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["className", "block", "onClick"]);
  var classes = (0, _styles.useStyles)();
  return /*#__PURE__*/_react.default.createElement(_Link.default, (0, _extends2.default)({
    className: (0, _classnames.default)("prmbl-link-inner", className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes.hasOnClick, Boolean(onClick)), (0, _defineProperty2.default)(_classNames, classes.block, block), _classNames)),
    variant: "inherit"
  }, otherProps));
};

exports.Link = Link;
Link.defaultProps = {
  underline: "hover",
  block: false,
  component: "a",
  color: "primary"
};
var _default = Link;
exports.default = _default;